import { create } from "zustand";

import pureStore from "./pureStore";

const useChildStore = create(pureStore);

export default useChildStore;
